import { render, staticRenderFns } from "./HomeFirst.vue?vue&type=template&id=ffc0b054&scoped=true&"
import script from "./HomeFirst.vue?vue&type=script&lang=js&"
export * from "./HomeFirst.vue?vue&type=script&lang=js&"
import style0 from "./HomeFirst.vue?vue&type=style&index=0&id=ffc0b054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc0b054",
  null
  
)

export default component.exports